import { createAction, props } from '@ngrx/store';

export const ORDER_ID_FROM_URL_ACTION = '[Order External Id] set order id';

export const setOrderExternalId = createAction(
  ORDER_ID_FROM_URL_ACTION,
  props<{ orderId: string }>()
);
